import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GameUser } from '../models/game-user';
import { map } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import { GameUserLimitations } from '../models/game-user-limitation';
import { GameUserDisqualification } from '../models/game-user-disqualification';

@Injectable({providedIn: 'root'})
export class GameBaseApi {
  constructor(
    protected httpClient: HttpClient,
    protected configService: ConfigService,
  ) {
  }

  async getUsers(gameId: number): Promise<GameUser[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/users/`).pipe(
      map(result => GameUser.toFront(result))
    ).toPromise();
  }

  async getMvp(gameId: number): Promise<GameUser[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/mvp/`).pipe(
      map(result => GameUser.toFront(result))
    ).toPromise();
  }

  async getUsersLimitation(gameId: number): Promise<GameUserLimitations[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/users_limitation/`).pipe(
      map(result => GameUserLimitations.toFront(result))
    ).toPromise();
  }

  async getUsersDisqualification(gameId: number): Promise<GameUserDisqualification[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/users_disqualification/`).pipe(
      map(result => GameUserDisqualification.toFront(result))
    ).toPromise();
  }

  async downloadApplication(gameId: number, format: 'pdf' | 'xlsx' | 'html', type: 'game_user' | 'tournament_user'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/game_application/`, {
      params: new HttpParams().set('file_type', format).set('application_type', type),
      responseType: 'blob'
    }).toPromise();
  }
}
